<template>
  <el-table :data="tableData" @selection-change="handleSelectionChange">
    <el-table-column type="selection" width="50"></el-table-column>

    <el-table-column type="index" width="50"></el-table-column>
    <el-table-column :label="$t('lang.图片')">
      <template v-slot="scope">
        <el-image
            style="width: 100px; height: 100px"
            :src="scope.row.photo | filterImg"
        />
      </template>
    </el-table-column>
    <el-table-column prop="recipeCategoryName" :label="$t('lang.分类')"></el-table-column>
    <el-table-column prop="name" :label="$t('lang.食谱名称')"></el-table-column>
    <el-table-column prop="number" :label="$t('lang.食谱编号')"></el-table-column>
    <el-table-column prop="modifyEdition" :label="$t('lang.食谱版本号')"></el-table-column>
    <el-table-column prop="lang" :label="$t('lang.食谱语言')"></el-table-column>
    <el-table-column prop="type" :label="$t('lang.食谱类型')">
      <template v-slot="{row}">
        {{row.type | recipeType(that)}}
      </template>
    </el-table-column>
    <el-table-column :label="$t('lang.支持型号')">
      <template v-slot="scope">
        <span>{{ scope.row.productModels | filterProduct }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="tags" :label="$t('lang.标签')"></el-table-column>
    <el-table-column prop="lastUpdateTimeStr" :label="$t('lang.更新时间')" ></el-table-column>
    <el-table-column label="" >
      <template v-slot="{row}">
        <nation-list :high-light="row.confirmLangList" :list="row.supportLangList" disabled />
      </template>
    </el-table-column>

    <el-table-column fixed="right" :label="$t('lang.操作')" width="400">
      <template v-slot="scope">
        <el-button
            size="mini"
            @click="
            $router.push({
              path: '/recipe-edit',
              query: { recipeEditionCode: scope.row.modifyEditionCode, code: scope.row.code }
            })
          "
            plain
            type="primary"
        >{{$t('lang.编辑')}}
        </el-button>
        <el-button size="mini" plain type="primary" @click="handleCopy(scope.row)">{{ $t('lang.复制') }}</el-button>

        <el-button size="mini" plain type="primary" @click="handlePreview(scope.row)">{{ $t('lang.预览') }}</el-button>
        <el-button size="mini" plain type="primary" @click="handleSubmit(scope.row)">{{ $t('lang.提交审核') }}</el-button>
        <el-button size="mini" plain type="danger" @click="handleDelete(scope.row)">{{ $t('lang.删除') }}</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import NationList from "../nation/NationList";
export default {
  name: "EditorTable",
  components: {NationList},
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      that: this,
    };
  },
  methods: {
    // 食谱预览
    handlePreview(row) {
        this.$router.push({
          path: '/preview-detail',
          query: {
            recipeEditionCode: row.modifyEditionCode,
            number: row.number
          }
        })
    },

    handleDelete(row) {
      this.$emit('remove', row)
    },
    handleSubmit(row) {
      this.$emit('submit', row)
    },
    handleSelectionChange(selection) {
      this.$emit("selection-change", selection);
    },
    handleCopy(row){
       this.$emit('copy',row)
    }
  },
  filters: {
    filterProduct(list) {
      if (Array.isArray(list)) {
        return list.join('/');
      }
      return ''
    }
  },
};
</script>

<style scoped lang="scss"></style>
